import {Component, EventEmitter, Input, Output, ViewEncapsulation} from '@angular/core';
import {kanMailsService} from "../../../services/services/mails";
import {Mail} from "../../../../classes/mail";
import {StateService} from "@uirouter/angular";
import {MatDialog} from "@angular/material";
import {kanRemoveDialog} from "../../../common/dialogs/remove-dialog/component";
import {kanMailDialog} from "../../dialogs/mail-dialog/component";
import {kanMailPreviewDialog} from "../../dialogs/mail-preview-dialog/component";

@Component({
    selector: 'kan-mail-list-item',
    templateUrl: './component.html',
    styleUrls: ['./component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class kanMailListItem {
    @Input() mail: Mail;
    @Output() refresh: EventEmitter<any> = new EventEmitter();
    public toggled: boolean = false;

    constructor(private stateService: StateService,
                private dialog: MatDialog,
                private mailService: kanMailsService) {
    }

    ngOnInit(): void {
    }

    public toggle() {
        this.toggled = !this.toggled;
    }

    public preview(event: any) {
        this.dialog.open(kanMailPreviewDialog, {
            data: {
                mail: this.mail
            },
            disableClose: true,
            width: '100%',
            maxWidth: '100%',
            height: '100%',
            maxHeight: '100%'
        });
    }

    public clone() {
        let clonedMail = {
            type: this.mail.type,
            to: this.mail.to,
            status: 'DRAFT',
            subject: this.mail.subject,
            body: this.mail.body,
            templateId: this.mail.templateId
        };

        this.mailService.addMail(clonedMail)
            .then(() => {
                this.refresh.emit();
            })
            .catch((error) => {
                console.log(error);
            });
    }

    public sendMail(event: any) {
        this.mailService.sendMail(this.mail)
            .then(() => {
                this.refresh.emit();
            })
            .catch((error) => {
                console.log(error);
            });
    }

    public editMailDialog(event: any) {
        let dialogRef = this.dialog.open(kanMailDialog, {
            data: {
                mail: this.mail
            },
            disableClose: true,
            width: '100%',
            maxWidth: '100%',
            height: '100%',
            maxHeight: '100%'
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result === 'update') {
                this.refresh.emit();
            }
        });
    }

    public removeMail(event: any) {
        let dialogRef = this.dialog.open(kanRemoveDialog, {
            disableClose: true
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result === 'remove') {
                this.mailService.removeMail(this.mail)
                    .then((data) => {
                        this.refresh.emit();
                    });
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/modules/mails/components/list-item/component.ts